import * as Yup from "yup";

export const PASSWORD_POLICY_HINT =
  "Use at least 8 characters with uppercase, lowercase, a number, and a special character.";

export const passwordComplexitySchema = Yup.string()
  .required("This field is required!")
  .min(8, "Password must be at least 8 characters.")
  .matches(/[A-Z]/, "Password must include at least one uppercase letter.")
  .matches(/[a-z]/, "Password must include at least one lowercase letter.")
  .matches(/[0-9]/, "Password must include at least one number.")
  .matches(
    /[^A-Za-z0-9]/,
    "Password must include at least one special character."
  );

export function passwordReminderMessage(daysRemaining) {
  const days = Math.max(0, Number(daysRemaining) || 0);
  if (days === 1) {
    return "Security notice: Your password expires tomorrow. Please change it within 1 day to avoid interruption.";
  }
  return `Security notice: Your password expires in ${days} days. Please change it within ${days} days to keep your account secure.`;
}
